import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip as PieTooltip,
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip as BarTooltip,
  Legend
} from 'recharts';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const DashboardCharts = ({ pieData, barData }) => {
  return (
    <div className='grid rounded-8 rounded-2xl bg-white/40 pl-0 md:pl-8 -ml-12 md-ml-0 lg:grid-cols-2 overflow-auto'>
     <div className='w-full md:w-8/10 place-items-center -mb-12 -ml-5 md:ml-0 '>
      <PieChart width={400} height={400}>
        <Pie
          data={pieData}
          cx={210}
          cy={150}
          label
          outerRadius={110}
          fill="#8884d8"
          dataKey="value"
        >
          {pieData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <PieTooltip />
      </PieChart>
     </div>
<div className='w-full md:w-2/10 place-items-center p-0 -ml-5 md:ml-0'>
      <BarChart
        width={410}
        height={320}
        data={barData}
        margin={{ top: 10, right: 30, left: 50, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <BarTooltip />
        <Legend />
        <Bar dataKey="value" fill="rgb(17 24 39)" />
      </BarChart>
        </div>
    </div>
  );
};

export default DashboardCharts;
